import React, {useEffect} from "react";
import {LoadingView} from "../loading";
import {useAuthenticationState} from "../../hooks/use-auth-state";

export interface AuthenticationRedirectViewProps {
    proceed: boolean;
    navigateToCoreUrl: (mode: 'logout' | 'login') => void;
    navigateToCachedRoute: () => void;
}

export const AuthenticationRedirectView: React.FC<AuthenticationRedirectViewProps> = ({proceed, navigateToCoreUrl, navigateToCachedRoute}) => {
    const {loggedIn} = useAuthenticationState();

    /**
     * Redirects the user to the login page if not logged in, else to the landing page
     */
    useEffect(() => {
        if (loggedIn) {
            return navigateToCachedRoute();
        }
        if (!proceed) {
            return;
        }
        const timer = setTimeout(() => {
            navigateToCoreUrl('logout');
        }, 1000);
        return () => {
            if (timer) {
                clearTimeout(timer);
            }
        }
    }, [navigateToCachedRoute, navigateToCoreUrl, proceed, loggedIn]);

    return (
        <LoadingView message={"Redirecting you to Login Page"}/>
    );
}